/** Nom court du site (balises & JSON-LD). */
export const SITE_NAME = 'Medelia Santé';

/** Description par défaut (meta & partages sociaux). */
export const DEFAULT_DESCRIPTION =
  'Medelia Santé — formations certifiées Qualiopi et accompagnement pour les professionnels de santé en France. DPC, FIFPL, OPCO, CPF.';

/** Image Open Graph par défaut (URL absolue recommandée pour les réseaux). */
export const DEFAULT_OG_IMAGE =
  'https://images.pexels.com/photos/7446989/pexels-photo-7446989.jpeg?auto=compress&cs=tinysrgb&w=1200';

export const CONTACT_EMAIL = 'contact@medelia-sante.com';

/** Domaine canonique attendu en production (sitemap / robots). À surcharger avec REACT_APP_SITE_URL. */
export const CANONICAL_SITE_ORIGIN = 'https://www.medelia-sante.com';

/**
 * URL de base du site (sans slash final). En prod, définir REACT_APP_SITE_URL pour un canonical stable.
 */
export function getSiteOrigin() {
  if (typeof window === 'undefined') {
    return (process.env.REACT_APP_SITE_URL || CANONICAL_SITE_ORIGIN).replace(/\/$/, '');
  }
  return (process.env.REACT_APP_SITE_URL || window.location.origin).replace(/\/$/, '');
}

export function absoluteUrl(pathnameAndSearch = '/') {
  const base = getSiteOrigin();
  const path = pathnameAndSearch.startsWith('/') ? pathnameAndSearch : `/${pathnameAndSearch}`;
  return `${base}${path}`;
}
